import Dropzone from 'react-dropzone';
import { Col, Row, Input, Label } from 'reactstrap';
import { setError } from 'slices/product/form/reducer';
import { handleAcceptedFiles, sendImageAPI, removeFile } from './FormHandlers';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'slices';
import { ProductFormDetailsInterface, SelectedFile } from 'types/productTypes';
import { Dispatch } from 'redux';
import { FormikProps } from 'formik';
import { ImageWithFallback } from 'Components/pos2u/ImageWithFallback';
import styles from 'pages/Products/styles/products.module.css';
import { truncateText } from 'utils/common/String';

export default function ProductImageUpload({
  dispatch,
  formik,
}: {
  dispatch: Dispatch;
  formik: FormikProps<ProductFormDetailsInterface>;
}) {
  const { t } = useTranslation();
  const productFormState = useSelector((state: RootState) => state.Product);
  const { selectedFiles, isEdit } = productFormState.form;
  return (
    <>
      <Col lg={6}>
        <Row className="justify-content-center">
          <Col sm={9}>
            <Dropzone
              onDrop={async (acceptedFiles) => {
                if (acceptedFiles.length > 1) {
                  dispatch(setError(t('Warn_select_1_file')));
                } else {
                  dispatch(setError(''));
                  const res = await handleAcceptedFiles(
                    acceptedFiles,
                    isEdit,
                    t,
                    dispatch
                  );
                  if (res !== null && typeof res === 'object') {
                    if (res.length > 0) {
                      await sendImageAPI(res, dispatch);
                    }
                  }
                }
              }}
              onDropRejected={() => {
                dispatch(setError(t('Warn_select_1_file')));
              }}
              maxFiles={1}
              multiple={false}
            >
              {({ getRootProps, getInputProps }) => (
                <div className="dropzone dz-clickable p-4 border rounded">
                  <div
                    className="dz-message needsclick text-center"
                    {...getRootProps()}
                  >
                    {selectedFiles.length === 0 ? (
                      <>
                        <div className="mb-3">
                          <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                        </div>
                        <h6>{t('ProductPage_PleaseUploadFile')}</h6>
                        <h6>{t('ProductPage_ImageFileSupport')}</h6>
                      </>
                    ) : (
                      <div className="text-center">
                        {selectedFiles.map((f: SelectedFile, i: number) => (
                          <div key={i}>
                            <div className="position-relative d-inline-block">
                              <ImageWithFallback
                                src={f.preview}
                                alt={truncateText(f.name, 20)}
                                style={{ width: 200 }}
                                errImgSize="10rem"
                                // className="rounded bg-light"
                              />
                              <div
                                className="position-absolute"
                                style={{
                                  top: '-10px',
                                  right: '-10px',
                                  backgroundColor: 'red',
                                  borderRadius: '50%',
                                  width: '1.5rem',
                                  height: '1.5rem',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: 'pointer',
                                }}
                                onClick={() =>
                                  removeFile(i, isEdit, selectedFiles, dispatch)
                                }
                              >
                                <i
                                  className="ri-close-fill"
                                  style={{
                                    color: 'white',
                                    fontSize: '1.25rem',
                                  }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input {...getInputProps()} />
                </div>
              )}
            </Dropzone>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col sm={9}>
            {/* Checkboxes */}
            <div className="form-check mt-4">
              <Input
                type="checkbox"
                className={`form-check-input ${styles['green-checked']}`}
                id="first_page_pos"
                name="first_page_pos"
                checked={formik.values.first_page_pos}
                onChange={formik.handleChange}
              />
              <Label className="form-check-label" htmlFor="first_page_pos">
                {t('ProductField_Show_HomePage_POS')}
              </Label>
            </div>

            <div className="form-check">
              <Input
                type="checkbox"
                className={`form-check-input ${styles['green-checked']}`}
                id="display_pos"
                name="display_pos"
                checked={formik.values.display_pos}
                onChange={formik.handleChange}
              />
              <Label className="form-check-label" htmlFor="display_pos">
                {t('ProductField_Show_Category_POS')}
              </Label>
            </div>
          </Col>
        </Row>
      </Col>
    </>
  );
}
